module.exports = __webpack_public_path__ + "img/aboutUs.e6c18953.png";